export type Loader<T> = () => Promise<T>;

export class LocaleLoader {
  private loadedLocales: Record<string, string> = {};

  public load<T>(loader: Loader<T>, locale: string): Promise<T | null> {
    if (!this.loadedLocales[locale]) {
      this.loadedLocales[locale] = locale;

      return loader()
        .then((loadedLocale: T): T => loadedLocale)
        .catch(() => null);
    }
    return Promise.resolve(null);
  }
}

export function createLocaleLoader(): LocaleLoader {
  return new LocaleLoader();
}
